import { useRef, useEffect } from 'react';

export function useMarkReadMessage(roomId, socketRef) {
  const ref = useRef(null);
  const lastSentRef = useRef(0);

  useEffect(() => {
    if (!roomId || !socketRef?.current) return;
    const el = ref.current;
    if (!el) return;

    const handle = () => {
      const now = Date.now();
      if (now - lastSentRef.current > 2000) {
        // console.log('mousemove HOOK');
        socketRef.current?.emit('readMessage', {
          roomId: roomId,
        });
        lastSentRef.current = now;
      }
    };

    el.addEventListener('mousemove', handle);
    return () => el.removeEventListener('mousemove', handle);
  }, [roomId, socketRef]);

  return ref;
}
